<template>
  <span>{{dataUser.name}}</span>
</template>

<script>
export default {
    name : 'MobileTicketUser',

    props : ["user", 'userId'],

    data() {
      return {
        dataUser : {}
      }
    },

    mounted() {
      console.log('#18 MobileTicketUser mounted', this.user);

      this.loadUser();
    },

    watch : {
      user() {
        this.loadUser();
      },

      userId() {
        this.loadUser();
      }
    },

    methods: {
      loadUser() {
        // 传了用户id
        if ( !!this.user ) {
            console.log('#35 MobileTicketUser, user 不为空', this.user);
            this.dataUser = this.user;
            return;
        }

        var _this = this;
        if ( !this.userId ) {
          console.log('#41 MobileTicketUser, user 和 userId 都为空', this.userId);
          return;
        }

        // 传了用户 id
        sdk.TicketUserApi().findByIdCached({
            id: _this.userId
        }).then(res => {
            this.dataUser = res || { id : this.userId, name : '用户 ' + this.userId };
        });
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileTicketUser.vue